"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deduplicateContentResourceReferenceList = exports.deduplicateContentResourceReferenceListByDeduplicationStrategy = exports.deduplicationStrategyFromLocaleSelectionArray = exports.getLocaleLanguageRating = void 0;
var parse_resource_id_util_1 = require("./parse-resource-id.util");
var localeRegex = /^[a-z]{2}-[A-Z]{2,3}$/;
var languageRegex = /^[a-z]{2}$/;
var getUniquenessGroupKeyFromIdParsed = function (idParsed) {
    return "rrn:" + idParsed.partition + ":" + idParsed.guid;
};
var isLocale = function (value) {
    return localeRegex.test(value);
};
var isLanguage = function (value) {
    return languageRegex.test(value);
};
function getLocaleLanguageRating(locale, language, dedupStrat) {
    var idxInDesiredLocales = dedupStrat.locales.indexOf(locale);
    if (idxInDesiredLocales !== -1) {
        return dedupStrat.locales.length - idxInDesiredLocales + (dedupStrat.languages ? dedupStrat.languages.length : 0);
    }
    if (dedupStrat.languages) {
        var idxInDesiredLanguages = dedupStrat.languages.indexOf(language);
        if (idxInDesiredLanguages !== -1) {
            return dedupStrat.languages.length - idxInDesiredLanguages;
        }
    }
    return -1;
}
exports.getLocaleLanguageRating = getLocaleLanguageRating;
function deduplicationStrategyFromLocaleSelectionArray(localeSelectionArray) {
    var dedupStrategy = localeSelectionArray.reduce(function (agg, localeVal) {
        if (isLocale(localeVal)) {
            agg.locales.push(localeVal);
        }
        else if (isLanguage(localeVal)) {
            agg.languages.push(localeVal);
        }
        else if (localeVal === '*') {
            agg.keepNotMatching = true;
        }
        else {
            throw new Error("Value " + localeVal + " is neither a valid locale string, language or wildcard (*) character." + " Cannot parse locale deduplication strategy");
        }
        return agg;
    }, { locales: [], languages: [], keepNotMatching: false });
    if (dedupStrategy.locales.length === 0 && dedupStrategy.keepNotMatching === false) {
        throw new Error("Unable to parse locale deduplication strategy without a locale.");
    }
    return dedupStrategy;
}
exports.deduplicationStrategyFromLocaleSelectionArray = deduplicationStrategyFromLocaleSelectionArray;
function deduplicateContentResourceReferenceListByDeduplicationStrategy(referenceList, dedupStrategy) {
    var groupedDuplicatesByTypeGUID = referenceList.reduce(function (agg, reference, referenceIdx) {
        if (reference.id) {
            var idParsed = parse_resource_id_util_1.parseResourceId(reference.id);
            if (idParsed && parse_resource_id_util_1.isContentResourceId(reference.id)) {
                var language = idParsed.language || '';
                var groupKey = getUniquenessGroupKeyFromIdParsed(idParsed);
                var groupVal = {
                    idParsed: idParsed,
                    idPosInRelationship: referenceIdx,
                    reference: reference,
                    localeRelevance: idParsed.locale ? getLocaleLanguageRating(idParsed.locale, language, dedupStrategy) : 0,
                };
                if (!agg.has(groupKey)) {
                    // @ts-ignore: no idea how to fix this
                    agg.set(groupKey, new Set());
                }
                // @ts-ignore: no idea how to fix this
                agg.set(groupKey, agg.get(groupKey).add(groupVal));
            }
        }
        return agg;
    }, new Map());
    var preferredLocaleOfDuplicateGroup = Array.from(groupedDuplicatesByTypeGUID.keys()).reduce(function (agg, typeGuidGroupKey) {
        // find best locale per group
        var dedupGroupSet = groupedDuplicatesByTypeGUID.get(typeGuidGroupKey) || new Set();
        var dedupGroupArray = Array.from(dedupGroupSet);
        var topMostReferencePositionOfDeduplicationGroup = dedupGroupArray.sort(function (parsedRel1, parsedRel2) {
            return parsedRel1.idPosInRelationship - parsedRel2.idPosInRelationship;
        })[0].idPosInRelationship;
        var referenceWithHighestLocaleRelevanceInDeduplicationGroup = dedupGroupArray.sort(function (parsedRel1, parsedRel2) {
            return parsedRel2.localeRelevance - parsedRel1.localeRelevance;
        })[0];
        if (referenceWithHighestLocaleRelevanceInDeduplicationGroup.localeRelevance !== -1 || dedupStrategy.keepNotMatching) {
            agg.push({
                reference: referenceWithHighestLocaleRelevanceInDeduplicationGroup.reference,
                idPosInRelationship: topMostReferencePositionOfDeduplicationGroup,
            });
        }
        return agg;
    }, []);
    return preferredLocaleOfDuplicateGroup
        .sort(function (groupA, groupB) {
        // re-sort relationships based on highest rank of type+guid in original relationship (lowest position (most on the top) first.
        return groupA.idPosInRelationship - groupB.idPosInRelationship;
    })
        .map(function (group) { return group.reference; });
}
exports.deduplicateContentResourceReferenceListByDeduplicationStrategy = deduplicateContentResourceReferenceListByDeduplicationStrategy;
/**
 * Takes a list of content-resource references and de-duplicates them according to the locale-mixing strategy provided.
 * @param {ContentResourceReference[]} referenceList - A list of content resource references that should be deduplicated
 * @param {string[]} localeMixingStrategy - A locale-mixing strategy, e.g.
 * ['en-SG', 'en-INT'], ['*'], ['en-SG', 'en-INT', 'en', '*'].
 * @returns {ContentResourceReference[]} - The de-duplicated list of resource references.
 */
function deduplicateContentResourceReferenceList(referenceList, localeMixingStrategy) {
    var dedupStrategyObject = deduplicationStrategyFromLocaleSelectionArray(localeMixingStrategy);
    return deduplicateContentResourceReferenceListByDeduplicationStrategy(referenceList, dedupStrategyObject);
}
exports.deduplicateContentResourceReferenceList = deduplicateContentResourceReferenceList;
//# sourceMappingURL=dedup-content-resource-ids.util.js.map